import inventory from './catalog/inventory.json';
import verified from './catalog/verified.json';

// Search metadata only. Catalog identities, observations and price rules remain unchanged.
const verifiedByEntry = new Map();
for (const product of verified.products) {
  for (const group of product.groups) {
    for (const option of group.options) {
      if (!verifiedByEntry.has(option.id)) verifiedByEntry.set(option.id, product);
    }
  }
}
export const productFor = id => verifiedByEntry.get(id);
export const serviceCategory = service => /Table tennis|Billiards|Air hockey/i.test(service) ? 'catalog-other' : /Pergola/i.test(service) ? 'pergola' : /Gazebo/i.test(service) ? 'gazebo' : /shed/i.test(service) ? 'shed' : /sauna/i.test(service) ? 'sauna' : /gym|Treadmill/i.test(service) ? 'gym' : /Playset/i.test(service) ? 'playground' : /furniture|seating|Tables|Desks/i.test(service) ? 'outdoor-furniture' : 'catalog-other';
export const categoryForServiceGroup = group => ({ furniture: 'outdoor-furniture', games: 'catalog-other' }[group] || (['gazebo', 'pergola', 'shed', 'sauna', 'gym', 'playground'].includes(group) ? group : ''));

export const clearedProductFields = {
  catalog_selection: null, product_type: '', structure_brand: '', product_size: '', product_size_custom: '',
  structure_material: '', roof_type: '', shed_material: '', foundation_type: '', platform_option: '',
};
export const initialCatalogBrowse = { query: '', context: '', limit: 30 };
const normalizeText = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
export function catalogSearchQuery(query) {
  const original = normalizeText(query);
  // These explicit requested spellings resolve to existing Yardistry records only.
  const normalized = original.replace(/\byardistri\b|\byard\s*street\b/g, 'yardistry');
  return { normalized, aliased: original !== normalized };
}
export function catalogSearchText(entry) {
  const product = productFor(entry.id);
  return normalizeText([entry.label, entry.service, entry.category, entry.screen, entry.section, product?.brand, product?.label, product?.service].filter(Boolean).join(' '));
}
const searchIndex = new Map(inventory.entries.map(entry => [entry.id, catalogSearchText(entry)]));
export function searchCatalog({ category = '', context = '', query = '' } = {}) {
  const tokens = catalogSearchQuery(query).normalized.split(' ').filter(Boolean);
  return inventory.entries.filter(entry => (!category || serviceCategory(entry.service) === category) && (!context || entry.screen === context) && tokens.every(token => searchIndex.get(entry.id).includes(token)));
}
